import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CTAButtonProps = {
  label: string;
  subtext?: string;
  id?: string;
  className?: string;
  tone?: 'light' | 'dark';
};
export function CTAButton({
  label,
  subtext,
  id,
  className = '',
  tone = 'light'
}: CTAButtonProps) {
  return <div className={`flex w-full flex-col items-center ${className}`} data-id="element-87" data-mp="2fy0gbqb0aw0l">
      <a id={id} href={CHECKOUT_URL} className="group flex w-full max-w-md items-center justify-center gap-2 whitespace-nowrap rounded-2xl border-b-[5px] border-cta-shadow bg-cta px-5 py-4 font-display text-[1.2rem] font-extrabold uppercase tracking-wide text-white shadow-[0_10px_30px_-8px_rgba(22,163,74,0.6)] transition-[background-color,transform] duration-150 ease-out hover:bg-cta-dark active:translate-y-[2px] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold sm:text-2xl" data-id="element-88" data-mp="2tyb5mowo42jn">
        {label}
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-89" data-mp="38m60oby5eizw" />
      </a>
      {subtext && <p className={`mt-3 text-center text-sm font-medium ${tone === 'dark' ? 'text-white/75' : 'text-muted'}`} data-id="element-90" data-mp="1db9qdxsfng1d">{subtext}</p>}
    </div>;
}